import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CareModel from '../models/ClassificationModel';
import ClassificationQueryModel from '../models/ClassificationQueryModel';
import ClassificationModel from '../models/ClassificationModel';
import Utility from '../../../app/utility';
import { OrderDirection } from '../../Datatable/OrderDirection';

interface ClassificationState {
    query: ClassificationQueryModel,
    searchResults: ClassificationModel[],
    triggerSearch: number,
    orderBy: string,
    orderDirection: OrderDirection,
}

const initialState: ClassificationState = {
    query: {
        searchDate: Utility.DateFormat.format(new Date()),
    } as ClassificationQueryModel,
    searchResults: [],
    triggerSearch: 0,
    orderBy: Utility.propertyOf<ClassificationModel>("clientName"),
    orderDirection: OrderDirection.Desc,
}

export const ClassificationSlice = createSlice({
    name: "Classification",
    initialState,
    reducers: {
        setSearchDate: (state, action: PayloadAction<string>) => {
            state.query.searchDate = action.payload;
        },
        setClassificationResults: (state, action: PayloadAction<CareModel[]>) => {
            state.searchResults = action.payload;
        },
        setTriggerSearchClassification: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
    }
});

export const ClassificationSelector = createSelector(
    (state: RootState) => state.classification,
    (data) => data
);

export const {
    setSearchDate,
    setClassificationResults,
    setTriggerSearchClassification,
    setOrderBy,
    setOrderDirection
} = ClassificationSlice.actions;

export default ClassificationSlice.reducer;